import { useState } from "react";
import { assets } from "../../publics/assets";
import LoginModal from "../../components/molecules/loginModal/LoginModal";
import LegalMentions from "../../components/molecules/legalMentions/LegalMentions";
import "./Login.css";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import WarningIcon from "@mui/icons-material/Warning";
import GavelIcon from "@mui/icons-material/Gavel";

const LEGAL_URL = "/legal-mentions";
const FIRE_RISK_URL = "https://www.ensemblepourlaforet.fr";

const Login = ({
  login,
  navigate,
  email,
  password,
  onChangeEmail,
  onChangePassword,
  appIsAvailable,
  showMentions,
  isAcceptingMentions,
  mentionsError,
  onAcceptMentions,
  onCloseMentions,
  loginError, // Add this prop
}) => {
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const loginInputs = [
    [
      {
        type: "email",
        placeholder: "Email",
        value: email,
        onChange: (e) => {
          onChangeEmail(e.target.value);
          setErrorMessage("");
        },
        icon: PersonIcon,
        name: "email",
        required: true,
      },
    ],
    [
      {
        type: "password",
        placeholder: "Mot de passe",
        value: password,
        onChange: (e) => {
          onChangePassword(e.target.value);
          setErrorMessage("");
        },
        icon: LockIcon,
        name: "password",
        required: true,
      },
    ],
  ];

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleLogin = async () => {
    setSubmitAttempted(true);
    if (!email) {
      setErrorMessage("Veuillez entrer votre email");
      return;
    }
    if (!validateEmail(email)) {
      setErrorMessage("Veuillez entrer une adresse email valide");
      return;
    }
    if (!password) {
      setErrorMessage("Veuillez entrer votre mot de passe");
      return;
    }
    await login();
  };

  const openLegal = () => {
    window.open(LEGAL_URL, "_blank", "noopener,noreferrer");
  };

  const openFireRisk = (e) => {
    e.preventDefault();
    window.open(FIRE_RISK_URL, "_blank", "noopener,noreferrer");
  };

  // Determine which error to display (local validation or server error)
  const displayError = errorMessage || loginError;

  return (
    <>
      {showMentions && (
        <LegalMentions
          onAccept={onAcceptMentions}
          isLoading={isAcceptingMentions}
          error={mentionsError}
          onClose={onCloseMentions}
        />
      )}

      {!appIsAvailable ? (
        <div
          className="login"
          style={{ backgroundImage: `url(${assets.loginBg})` }}
        >
          <div className="login-partner-logos">
            <img
              src={assets.companiesLogos}
              alt="Climate Innov"
              className="partner-logo"
            />
            {/* <img
              src={assets.edhecLogo}
              alt="EDHEC Climate Institute"
              className="partner-logo"
            /> */}
          </div>

          <LoginModal
            title="CONNEXION"
            buttonLabel="Se connecter"
            logoSrc={assets.ActionLogo}
            onSubmit={handleLogin}
            inputs={loginInputs}
            footer={
              <>
                {submitAttempted && displayError && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignContent: "center",
                      gap: "4px",
                    }}
                  >
                    <WarningIcon style={{ color: "#ff4444" }} />
                    <p
                      className="error-message"
                      data-testid="login-error-message"
                    >
                      {displayError}
                    </p>
                  </div>
                )}
              </>
            }
          />

          <button className="login-legal-btn" onClick={openLegal}>
            <GavelIcon style={{ fontSize: "14px" }} />
            Mentions légales
          </button>

          <div className="login-fire-risk-container">
            <span className="fire-risk-text">
              Vous pouvez consulter la carte des risques de feux de forêt sur 36
              heures :{" "}
              <a
                href={FIRE_RISK_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="fire-risk-link"
                onClick={openFireRisk}
              >
                ensemblepourlaforêt.fr
              </a>
            </span>
          </div>
        </div>
      ) : (
        <div
          className="maintenance"
          style={{ backgroundImage: `url(${assets.loginBg})` }}
        >
          <div
            className="maintenance-opacity"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="maintenance-logo-container">
              <img
                src={assets.configuration}
                alt="logo"
                className="config1-logo"
              />
            </div>
            <p className="maintenance-title">
              L'application est actuellement en maintenance
            </p>
            <div className="maintenance-content">
              <p>
                L'application est temporairement indisponible pour cause de
                maintenance !<br />
                Tout sera bientôt prêt pour vous offrir une meilleure
                expérience.
                <br />
                Merci de votre patience et de votre compréhension.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
